import Utility from '../classes/Utility';

class AdUnitSize {
  static ausInstance = null;

  static instance() {
    AdUnitSize.ausInstance = AdUnitSize.ausInstance || new AdUnitSize();

    return AdUnitSize.ausInstance;
  }

  static SIZES = {
    npa: {
      m: {
        adUnitSizes: [[320, 50]],
        initAdUnit: [300, 250]
      },
      t: {
        adUnitSizes: [[300, 250], [320, 50]],
        initAdUnit: [728, 90]
      },
      dt: {
        adUnitSizes: [[160, 600], [300, 250], [300, 600]],
        initAdUnit: [120, 600]
      }
    },
    npb: {
      m: {
        adUnitSizes: [],
        initAdUnit: null
      },
      t: {
        adUnitSizes: [],
        initAdUnit: [300, 250]
      },
      dt: {
        adUnitSizes: [],
        initAdUnit: [300, 250]
      }
    },
    npc: {
      m: {
        adUnitSizes: [],
        initAdUnit: null
      },
      t: {
        adUnitSizes: [],
        initAdUnit: null
      },
      dt: {
        adUnitSizes: [[160, 600], [300, 250], [300, 600]],
        initAdUnit: [120, 600]
      }
    },
    wpa: {
      m: {
        adUnitSizes: [[320, 50]],
        initAdUnit: [300, 250]
      },
      t: {
        adUnitSizes: [[300, 250], [320, 50]],
        initAdUnit: [728, 90]
      },
      dt: {
        adUnitSizes: [[300, 250], [320, 50]],
        initAdUnit: [728, 90]
      }
    },
    wpax: {
      m: {
        adUnitSizes: ['fluid'],
        initAdUnit: null
      },
      t: {
        adUnitSizes: ['fluid'],
        initAdUnit: null
      },
      dt: {
        adUnitSizes: ['fluid'],
        initAdUnit: null
      }
    },
    fpa: {
      m: {
        adUnitSizes: [[320, 50]],
        initAdUnit: [300, 250]
      },
      t: {
        adUnitSizes: [[300, 250], [320, 50]],
        initAdUnit: [728, 90]
      },
      dt: {
        adUnitSizes: [[300, 250], [320, 50], [970, 90], [970, 250]],
        initAdUnit: [728, 90]
      }
    },
    sba: {
      m: {
        adUnitSizes: [[320, 50]],
        initAdUnit: [300, 250]
      },
      t: {
        adUnitSizes: [[300, 250], [320, 50]],
        initAdUnit: [728, 90]
      },
      dt: {
        adUnitSizes: [[300, 250], [320, 50], [970, 90], [970, 250]],
        initAdUnit: [728, 90]
      }
    },
    fpax: {
      m: {
        adUnitSizes: ['fluid'],
        initAdUnit: null
      },
      t: {
        adUnitSizes: ['fluid'],
        initAdUnit: null
      },
      dt: {
        adUnitSizes: ['fluid'],
        initAdUnit: null
      }
    },
    oa: {
      m: {
        adUnitSizes: [],
        initAdUnit: [320, 480]
      },
      t: {
        adUnitSizes: [],
        initAdUnit: [768, 1024]
      },
      dt: {
        adUnitSizes: [],
        initAdUnit: [640, 480]
      }
    },
    srax: {
      m: {
        adUnitSizes: ['fluid'],
        initAdUnit: null
      },
      t: {
        adUnitSizes: ['fluid'],
        initAdUnit: null
      },
      dt: {
        adUnitSizes: ['fluid'],
        initAdUnit: null
      }
    },
    ctax: {
      m: {
        adUnitSizes: ['fluid'],
        initAdUnit: null
      },
      t: {
        adUnitSizes: ['fluid'],
        initAdUnit: null
      },
      dt: {
        adUnitSizes: ['fluid'],
        initAdUnit: null
      }
    },
    ctax1: {
      m: {
        adUnitSizes: ['fluid'],
        initAdUnit: null
      },
      t: {
        adUnitSizes: ['fluid'],
        initAdUnit: null
      },
      dt: {
        adUnitSizes: ['fluid'],
        initAdUnit: null
      }
    },
  }

  static DEFAULT_SIZE = [[120, 600], [160, 600], [300, 250], [320, 50], [320, 480], [300, 600], [640, 480], [728, 90], [768, 1024], [970, 90], [970, 250]]

  getSize = (unitType) => {
    if (AdUnitSize.SIZES[unitType] == undefined) { return ['fluid']; }

    const deviceType = Utility.getDeviceType();
    return this.getSizeByDevice(unitType, deviceType)
  }

  getSizeMapping = () => {
    return AdUnitSize.SIZES;
  }

  getSizeByDevice = (unitType, deviceType) => {
    let adUnitSizes = AdUnitSize.SIZES[unitType][deviceType]['adUnitSizes']
    const initAdUnit = AdUnitSize.SIZES[unitType][deviceType]['initAdUnit']

    if (initAdUnit && adUnitSizes[0] != initAdUnit) {
      adUnitSizes.unshift(initAdUnit)
    }
    return adUnitSizes
  }
}

export default AdUnitSize.instance();
